import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import useSettingsService from 'components/hooks/useSettingsService';
import { ACCOUNT_TYPES_MAP, FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { myAccountSelector, accountsSelector } from 'state/selectors/account';
import { getAccounts } from 'state/callers';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { useEffect } from 'react';

const useNoTeams = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const myAccount = useSelector(myAccountSelector);
  const accounts = useSelector(accountsSelector);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isRBACEnabledFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isRBACEnabled
  });
  const scopes = _.get(myAccount, 'account_scopes', []);
  // Allow any user to access Survey Execution page inside the organization
  const showNoTeamsEmptyState = isRBACEnabledFF
    ? !scopes.length &&
      !history.location?.pathname.includes(AppRouter.SURVEYS_EXECUTION.path)
    : false;

  const adminToPresent = accounts?.find(
    account =>
      account?.id !== myAccount?.id &&
      account?.type_id === ACCOUNT_TYPES_MAP.Primary
  );

  useEffect(() => {
    if (showNoTeamsEmptyState) {
      dispatch(getAccounts());
      history.push(AppRouter.NO_TEAMS.path);
    }
  }, [isRBACEnabledFF]);

  return { adminToPresent, showNoTeamsEmptyState };
};

export default useNoTeams;
